// extracted by css-extract-rspack-plugin
export default {"silver":"_6fbc0da4","silverBorder":"_19f448a8","gold":"_49e52113","goldBorder":"_5fd5cb1f","platinum":"_c5940dc5","platinumBorder":"_4271dec9","bullets":"_24633126"};